const SET_IS_LOADING = (state, payload) => { state.isLoading = payload }
const RESET_IS_LOADING = (state) => { state.isLoading = 0 }

const SET_AGENTS = (state, payload) => { state.agents = payload }
const RESET_AGENTS = (state) => { state.agents = [] }

const SET_CLIENTS = (state, payload) => { state.clients = payload }
const RESET_CLIENTS = (state) => { state.clients = [] }

const SET_TRANSACTION = (state, payload) => { state.input_transaction = payload }
const RESET_TRANSACTION = (state) => {
  state.input_transaction = {
    products: [{
      item: {
        product: {}, uuid: "", product_name: "", type: "", price: 0.00, discount: 0.00, final_price: 0.00, isPercentage: false, 
        observation: "", category: "", subcategory: "",
      },
      booking: { product_place: "", observation: "", date: "", time: "", people: "" },
      readonly: false, removed: false,
    }],
    payments: [{
      payment_method: { index: null, name: "" }, value: 0.00, date: "", cv: "", aut: "", pix_id: "", invoice_number: "", customer_name: "", customer_document: "",
      readonly: false, removed: false,
    }],
    general: { id: null, user: { uuid: "", name: "", }, date: "", label: "", open: true, bill_final_value: 0.00, bill_total_value: 0.00, bill_total_discount: 0.00, bill_status: "", },
    type:"1",
  }
}

const SET_CURRENT_OUTPUT_TRANSACTION = (state, payload) => { state.output_transaction = payload }
const RESET_CURRENT_OUTPUT_TRANSACTION = (state) => {
  state.output_transaction = {
    payment: {
      payment_method: {index:null, name: ""}, value: 0.00, date: "", cv: "", aut:"", pix_id:"", invoice_number: "", supplier_name: "", supplier_document: "",
    },
    general: { id: null, user: { uuid: "", name: "", }, date: "", label: "", observation:"", },
    type:"0",
  }
}

const SET_REQUEST_ARRAY_INPUT_STATUS = (state, payload) => { state.requestArrayInputStatus = payload }
const RESET_REQUEST_ARRAY_INPUT_STATUS = (state) => { state.requestArrayInputStatus = [] }
const SET_INDEX_VALUE_REQUEST_ARRAY_INPUT_STATUS = (state, payload) => { state.requestArrayInputStatus[payload.index] = payload.value }

const SET_REQUEST_ARRAY_OUTPUT_STATUS = (state, payload) => { state.requestArrayOutputStatus = payload }
const RESET_REQUEST_ARRAY_OUTPUT_STATUS = (state) => { state.requestArrayOutputStatus = [] }
const SET_INDEX_VALUE_REQUEST_ARRAY_OUTPUT_STATUS = (state, payload) => { state.requestArrayOutputStatus[payload.index] = payload.value }

const SET_FINANCE_REPORT_DATA = (state, payload) => { state.financeReportData = payload }
const RESET_FINANCE_REPORT_DATA = (state) => { state.financeReportData = [] }
const SET_INDEX_VALUE_FINANCE_REPORT_DATA = (state, payload) => { state.financeReportData[payload.index] = payload.value }

const SET_INPUT_TRANSACTIONS = (state, payload) => { state.inputTransactions = payload }
const RESET_INPUT_TRANSACTIONS = (state) => { state.inputTransactions = [] }
const PUSH_TO_INPUT_TRANSACTIONS = (state, payload) => {
  let currentPayments = [...payload]
  let editedPayments = []

  if (payload[0] != undefined && payload[0].payments != undefined) {

    currentPayments = []
    currentPayments = [...state.inputTransactions]

    if (payload.isNew) {
      payload[0].payments.map((newPayment) => {
       if(newPayment){
         editedPayments.push({
          id: newPayment.id,
          t: `${payload[0].general.label} ${payload[0].payments.length > 1 ? ' (parcial)' : ''}`,
          des: '',
          d: newPayment.date,
          v: newPayment.value,
          tp: 1,
          pr: null,
          pe: null,
          pid: payload[0].general.id,
          aid: payload[0].general.user.uuid,
          cat: '',
          pu: 0,
          cid: newPayment.customer_name + '(' + newPayment.customer_document + ')',
          name: newPayment.customer_name + '(' + newPayment.customer_document + ')',
          cpf: newPayment.customer_document,
          pm: newPayment.payment_method.index,
          p: newPayment.date,
          xfields: JSON.stringify(payload[0])
        })
       }
      })
    }

    else {
      currentPayments = []
      state.inputTransactions.map((statePayment) => {
        let updatedPayment = payload[0].payments.find(editedPayment => editedPayment.id == statePayment.id)
        if (!updatedPayment) {
          currentPayments.push(statePayment)
        }
        return statePayment
      })

      payload[0].payments.map((newPayment) => {
        if (newPayment.id != payload[0].general.id && !newPayment.removed) {
          editedPayments.push({
            id: newPayment.id,
            t: `${payload[0].general.label} ${payload[0].payments.length > 1 ? ' (parcial)' : ''}`,
            des: '',
            d: newPayment.date,
            v: newPayment.value,
            tp: 1,
            pr: null,
            pe: null,
            pid: payload[0].general.id,
            aid: payload[0].general.user.uuid,
            cat: '',
            pu: 0,
            cid: newPayment.customer_name + '(' + newPayment.customer_document + ')',
            name: newPayment.customer_name + '(' + newPayment.customer_document + ')',
            cpf: newPayment.customer_document,
            pm: newPayment.payment_method.index,
            p: newPayment.date,
            xfields: JSON.stringify(payload[0])
          })
        }
      })
    }
  }

  state.inputTransactions = [...currentPayments, ...editedPayments]
}

const SET_OUTPUT_TRANSACTIONS = (state, payload) => { state.outputTransactions = payload }
const RESET_OUTPUT_TRANSACTIONS = (state) => { state.outputTransactions = [] }

const PUSH_TO_OUTPUT_TRANSACTIONS = (state, payload) => {
  var outputItem = payload
  var newItem = null

  if (payload.isNew) {
    outputItem = {}
    newItem = {
      general: payload[0].general,
      payment: payload[0].payments[0],
    }

    outputItem.t = `${newItem.general.label}`
    outputItem.des = ''
    outputItem.d = newItem.payment.date
    outputItem.v = newItem.payment.value
    outputItem.tp = 1
    outputItem.pr = null
    outputItem.pe = null
    outputItem.pid = newItem.general.id
    outputItem.aid = newItem.general.user.uuid
    outputItem.cat = ''
    outputItem.pu = 0
    outputItem.cid = newItem.payment.supplier_name + '(' + newItem.payment.supplier_document + ')'
    outputItem.name = newItem.payment.supplier_name + '(' + newItem.payment.supplier_document + ')'
    outputItem.cpf = newItem.payment.supplier_document
    outputItem.pm = newItem.payment.payment_method.index
    outputItem.p = newItem.payment.date
    outputItem.payment = newItem.payment
    outputItem.xfields = newItem.xfields ? newItem.xfields : JSON.stringify(newItem.payment)
    outputItem = [outputItem]
  }
  else{
    outputItem.map(function(value, index){
      value.xfields = typeof value.xfields === 'string' ? JSON.parse(value.xfields) : value.xfields
    })
  }

  state.outputTransactions =  [...state.outputTransactions, ...outputItem]
}

const SET_RESPONSE_INPUT_FILTER = (state, payload) => { state.responseInputFilter = payload }
const RESET_RESPONSE_INPUT_FILTER = (state) => { state.responseInputFilter = [] }

const SET_RESPONSE_OUTPUT_FILTER = (state, payload) => { state.responseOutputFilter = payload }
const RESET_RESPONSE_OUTPUT_FILTER = (state) => { state.responseOutputFilter = [] }

const SET_SUPER_ARRAY_INPUT_TRANSACTIONS = (state, payload) => { state.superArrayInputTransactions = payload }
const RESET_SUPER_ARRAY_INPUT_TRANSACTIONS = (state) => { state.superArrayInputTransactions = [] }

const SET_SUPER_ARRAY_OUTPUT_TRANSACTIONS = (state, payload) => { state.superArrayOutputTransactions = payload }
const RESET_SUPER_ARRAY_OUTPUT_TRANSACTIONS = (state) => { state.superArrayOutputTransactions = [] }

export default {
  SET_AGENTS,
  RESET_AGENTS,

  SET_IS_LOADING,
  RESET_IS_LOADING,

  SET_CLIENTS,
  RESET_CLIENTS,

  SET_TRANSACTION,
  RESET_TRANSACTION,

  SET_CURRENT_OUTPUT_TRANSACTION,
  RESET_CURRENT_OUTPUT_TRANSACTION,

  SET_REQUEST_ARRAY_INPUT_STATUS,
  RESET_REQUEST_ARRAY_INPUT_STATUS,
  SET_INDEX_VALUE_REQUEST_ARRAY_INPUT_STATUS,

  SET_REQUEST_ARRAY_OUTPUT_STATUS,
  RESET_REQUEST_ARRAY_OUTPUT_STATUS,
  SET_INDEX_VALUE_REQUEST_ARRAY_OUTPUT_STATUS,

  SET_FINANCE_REPORT_DATA,
  RESET_FINANCE_REPORT_DATA,
  SET_INDEX_VALUE_FINANCE_REPORT_DATA,

  SET_INPUT_TRANSACTIONS,
  PUSH_TO_INPUT_TRANSACTIONS,
  RESET_INPUT_TRANSACTIONS,

  SET_OUTPUT_TRANSACTIONS,
  PUSH_TO_OUTPUT_TRANSACTIONS,
  RESET_OUTPUT_TRANSACTIONS,

  SET_RESPONSE_INPUT_FILTER,
  RESET_RESPONSE_INPUT_FILTER,

  SET_RESPONSE_OUTPUT_FILTER,
  RESET_RESPONSE_OUTPUT_FILTER,

  SET_SUPER_ARRAY_INPUT_TRANSACTIONS,
  RESET_SUPER_ARRAY_INPUT_TRANSACTIONS,

  SET_SUPER_ARRAY_OUTPUT_TRANSACTIONS,
  RESET_SUPER_ARRAY_OUTPUT_TRANSACTIONS
}
